<template>
  <div 
    @click="$emit('click-on-profile')"
    class="private-person-item-content"
    :class="[profileChosenClass]"
  >
    <div class="private-person-item-picture">
      <img
        @click.stop="$emit('click-on-like')"
        :src="likeImage"
        class="private-person-item-picture--like"
        width="20px"
        :alt="$t('private_person_item.like_alt')"
        :style="likeImageStyle"
      />

      <img
        class="private-person-item-picture--image"
        :alt="$t('private_person_item.picture_alt')"
        v-if="privatePerson.pictures.length > 0"
        :src="privatePerson.pictures[0].file"
      />
      <img
        class="private-person-item-picture--image"
        :alt="$t('private_person_item.picture_alt')"
        v-else
        src="@/assets/images/private_person/default_user.jpg"
      />
    </div>
    <div class="private-person-item-content-name">
      {{privatePerson.user.first_name}} 
      <span
        v-if="!privatePerson.hide_your_name"
      >
        {{privatePerson.user.last_name}}
      </span>
    </div>
    <div class="private-person-item-content-body">
      {{privatePerson.profession ? privatePerson.profession : ' '}}
    </div>
    <div v-if="isProfileChosen" class="text-center mt-2">
      {{privatePerson.age_range ? $t('private_person_item.age_label', { age: privatePerson.age_range }) : ' '}}
      <br>
      <div
        class="text-center"
      >
        {{ $t('private_person_item.want_to_connect') }}<br>
        {{ $t('private_person_item.send_whatsapp_request') }}<br>
        <button
          class="profile-validation-button private-person-item-content--whatsapp-button"
          @click.stop="$emit('click-on-whatsapp')"
        >
          {{ $t('private_person_item.whatsapp_button') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivatePersonItem',
  props: {
    chosenProfile: {
      type: Object,
      default: null
    },
    privatePerson: {
      type: Object,
      required: true
    },
    userId: {
      type: Number,
      default: null
    },  
  },
  computed: {
    isProfileChosen () {
      return this.chosenProfile && this.chosenProfile.id === this.privatePerson.id
    },
    likeImage () {
      return this.privatePerson.likes.includes(this.userId)
        ? require('@/assets/images/private_person/marque_page.svg')
        : require('@/assets/images/private_person/add.svg')
    },
    likeImageStyle () {
      return this.privatePerson.likes.includes(this.userId)
        ? {
          top: '0px',
        }
        : {
          top: '10px',
        }
    },
    profileChosenClass () {
      return this.isProfileChosen ? 'private-person-item-content--chosen' : ''
    }
  }
}
</script>

<style>
.private-person-item-content {
  border: 1px solid #ccc;
  border-radius: 10px;
  cursor: pointer;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;
  height: 280px;
  width: 100%;
  position: relative;
}

.private-person-item-content--chosen {
  height: unset;
}

.private-person-item-picture--like {
  cursor: pointer;
  position: absolute;
  right: 10px;

}

.private-person-item-picture {
  display: flex;
  justify-content: center;
  align-items: center;
}

.private-person-item-picture--image {
  height: 150px;
  width: 150px;
  object-fit: cover; /* Crop and fill the box */
  border-radius: 50%; /* Makes it a circle */
}

.private-person-item-content-name {
  margin-top: 10px;
  font-size: 1.2em;
  font-weight: bold;
  text-align: center;
}

.private-person-item-content-body {
  font-size: 1em;
  color: #666;
  text-align: center;
}
.private-person-item-content--profession {
  font-size: 0.9em;
  color: #999;
}

.private-person-item-content--whatsapp-button {
  background-color: #4179af;
  color: white;
  border: none;
  border-radius: 20px;
  margin-top: 5px;
}
</style>